import React from "react";
import {
  Button,
  Flex,
  Text,
  FormControl,
  FormLabel,
  Tooltip,
  Spinner,
  Center
} from "@chakra-ui/react";
import { ExternalLinkIcon } from '@chakra-ui/icons'
import { ModalBox } from "../../components/ModalBox";
import { SubscriptionPlan } from "../../components/SubscriptionPlan";
import { StaticUploadImage } from "../../components/StaticUploadImage";
import { OneTimePlan } from "../../components/OneTimePlan";
import { FormRadio } from "../../components/FormRadio";
import { FormChecklist } from "../../components/FormChecklist";
import { FormSelect } from "../../components/FormSelect";
import { CreateCatalogPage } from "../CreateCatalogPage"
import { CreatePricingForm } from "../../components/CreatePricingForm";
import { useUpdateBook } from "./useUpdateBook"
import { LoadingOverlay } from "../../components/LoadingOverlay";
import { FormInput } from "../../components/FormInput";
import { WYSIWYGEditor } from "../../components/WYSIWYGEditor"
import { cleanHtml } from "../../utils/helper"
import { pk_12 } from "../../config";
import { openViewer } from "../../utils/helper";
import { HelmetComponent } from "../../components/HelmetComponent";

export const UpdateBookPage = () => {
  const {
    publisher,
    product,
    addContent,
    handleChange,
    dynoGrades,
    dynoSubjects,
    productGrades,
    productSubjects,
    checklistCallback,
    catalogs,
    catalogId,
    staff,
    productAdmins,
    createCatalogOnOpen,
    plan,
    frequencyOptions,
    handleChangeCallback,
    resetPlanAndCloseModal,
    createUpdateOneTimeProductPlan,
    createUpdateSubscriptionProductPlan,
    createCatalogIsOpen,
    createCatalogOnClose,
    dynoCategories,
    buttonText,
    setCoverFile,
    setProductCategory,
    setCatalogId,
    isOpen,
    loading,
    showErrorMessage,
    product_Id,
    productSubscriptions,
    oneTimePlans,
    user,
    dynoSubCategories,
    setProductSubCategory,
    subCategoriesLoading
  } = useUpdateBook();
  const showButton = product?.productContent?.dynoList[0]?._count?.dynosUnderList !==0 && product?.productContent?.dynoList[0]?._count?.dynosUnderList !== undefined
  return (
    <>
      <HelmetComponent title={`Create Book - Home - ${user.firstName} ${user.lastName}`}/>
      {loading && <LoadingOverlay />}
      {
        showButton ? 
        <Flex justifyContent="flex-end">
          <Tooltip label={`Preview the ${product.productType}`} hasArrow bg='gray.700'>
            <a href={openViewer(product.id)} target="_blank" rel="noreferrer">
              <Button colorScheme="blue" variant="outline" fontSize="14px" size='sm'>Preview {product.productType}<ExternalLinkIcon ml={1} /></Button>
            </a>
          </Tooltip>
        </Flex> : <></>
      }
      <form onSubmit={addContent}>
        <Flex>
          <FormInput
            label="Book Name"
            name="productName"
            type="text"
            inputOnChange={handleChange}
            value={product.productName}
            formProps={{ isRequired: true }}
            padding="20px 15px 0 0"
          />
          <FormInput
            label="Heading"
            name="productHeading"
            type="text"
            inputOnChange={handleChange}
            value={product.productHeading}
            formProps={{ isRequired: true }}
            padding="20px 0 0"
          />
        </Flex>
        <FormControl padding="20px 0 0" isRequired={true}>
          <FormLabel
            fontSize="15px"
            textTransform="capitalize"
            fontWeight={600}
          >
            Description
          </FormLabel>
          <WYSIWYGEditor
            initialContent={cleanHtml(product?.productDescription)}
            handleChange={(e) => handleChange({target: {name: "productDescription", value: e}})}
          />
        </FormControl>
        <StaticUploadImage
          label="Cover Image"
          labelProps={{ padding: "20px 0 0", fontSize: "14px", fontWeight: 600 }}
          imageUrl={product.productCoverPath ? product.productCoverPath : ""}
          maxSize={5}
          maxWidth={600}
          maxHeight={400}
          parentCallback={(img_file) => setCoverFile(img_file)}
        />
        <FormRadio
          name="Category"
          radioGroupName="productType"
          value={product?.productCategory}
          onChange={setProductCategory}
          array={dynoCategories}
          id="grade"
          isObject={true}
          padding="20px 0 0"
          isRequired={true}
        />
        {
          subCategoriesLoading ? <Center m={5}><Spinner /></Center> :
          product?.productCategory !== pk_12 ?
          <FormRadio
            name="Sub Category"
            radioGroupName="productType"
            value={product?.productSubCategory}
            onChange={setProductSubCategory}
            array={dynoSubCategories}
            id="grade"
            isObject={true}
            padding="20px 0 0"
            isRequired={true}
          /> : <></>
        }
        {
          (product?.productCategory === pk_12) ?
            <>
              <FormChecklist
                name="Assign Grades"
                checkList={dynoGrades}
                selectedList={productGrades}
                checklistCallback={(list) => checklistCallback("productGrades", list)}
                padding="20px 0 0"
                itemPerRow={6}
                isRequired={true}
              />
              <FormChecklist
                name="Assign Subjects"
                checkList={dynoSubjects}
                selectedList={productSubjects}
                checklistCallback={(list) => checklistCallback("productSubjects", list)}
                padding="20px 0 0"
                itemPerRow={6}
                isRequired={true}
              />
            </> : <></>
        }
        <FormRadio
          name="Pricing type"
          radioGroupName="productPricingType"
          value={product?.productPricingType}
          onChange={(value) => handleChange({ target: { name: 'productPricingType', value: value } })}
          array={["Subscription", "OneTimePurchase"]}
          isObject={false}
          padding="20px 0 0"
          isRequired={true}
          disabled={window.location.href.includes("updatebook")}
        />
        {product_Id && product?.productPricingType === "OneTimePurchase" && oneTimePlans.length === 0 ? <Button variant="ghost" padding={0} height={0} fontSize="14px" color="blue.500" onClick={() => handleChange({ target: { name: 'addPlan' } })}>+ Add Pricing</Button> : <></>}
        {product_Id && product?.productPricingType === "Subscription" && productSubscriptions.length <= 1 ? <Button variant="ghost" padding={0} height={0} fontSize="14px" color="blue.500" onClick={() => handleChange({ target: { name: 'addPlan' } })}>+ Add Pricing</Button> : <></>}
        {showErrorMessage ? <Text color="red">Please create the Stripe Connect Account to create plan.</Text> : <></>}
        {
          (product?.productPricingType === "Subscription" && productSubscriptions.length > 0) ?
            <SubscriptionPlan subscriptionPlans={productSubscriptions} onEdit={(id) => handleChange({ target: { name: 'updatePlan' } }, id, "productSubscriptionPlans")}/> : 
          (product?.productPricingType === "OneTimePurchase" && oneTimePlans.length > 0) ?
            <OneTimePlan oneTimePlans={oneTimePlans} onEdit={(id) => handleChange({ target: { name: 'updatePlan' } }, id, "productOneTimePlans")}/> : <></>
        }
        <FormSelect
          formProps={{
            isRequired: true,
            maxWidth: "200px",
          }}
          padding= "20px 0 0"
          label="Select Catalog"
          value={catalogId}
          options={catalogs.length > 0 ? catalogs.map(c => ({ value: c.id, name: c.catalogName })) : []}
          name="catalogs"
          selectOnChange={(e) => setCatalogId(e.target.value)}
        />
        {!window.location.href.includes("updatebook") ? <Button variant="ghost" padding={0} height={0} fontSize="14px" color="blue.500" onClick={createCatalogOnOpen}>+ Add New Catalog</Button> : <></>}
        <FormChecklist
          name="Assigned Book Admins"
          checkList={staff}
          selectedList={productAdmins}
          checklistCallback={(list) => checklistCallback("productAdmins", list)}
          padding="20px 0 0"
          itemPerRow={4}
          isRequired={true} />
        <Flex flexDirection={{ base: "column", md: "row" }} mt={5}>
          <Button
            type="submit"
            colorScheme="blue"
            background="#1b6ec2"
            fontWeight="600"
          >
            {buttonText}
          </Button>
        </Flex>
      </form>
      <ModalBox
        title="Plan"
        description={
          <CreatePricingForm
            isPlanCreated={!!plan.id}
            price={plan.price}
            frequency={plan.frequency}
            frequencyOptions={frequencyOptions}
            handleChangeCallback={handleChangeCallback}
            productPricingType={product?.productPricingType}
          />
        }
        isOpen={isOpen}
        onClose={resetPlanAndCloseModal}
        isFooter={true}
        cancelButtonText="Cancel"
        confirmButtonText={plan.id ? "Update" : "Create"}
        onCancel={resetPlanAndCloseModal}
        onConfirm={() => {
          const plan_copy = { ...plan };
          product?.productPricingType === "Subscription" ? createUpdateSubscriptionProductPlan(plan_copy): createUpdateOneTimeProductPlan(plan_copy)
          resetPlanAndCloseModal();
        }}
      />
      <ModalBox
        title="Create Catalog"
        description={
          <CreateCatalogPage isHidden={true} isNoPadding={true} publisher={publisher} />
        }
        isNoPadding={true}
        size="xl"
        styleProps={{
          maxWidth: "960px",
        }}
        isOpen={createCatalogIsOpen}
        onClose={createCatalogOnClose}
        isFooter={false}
        loading={loading}
      />
    </>
  );
};
